<template>
  <div id="app">
    <v-app>
      <router-view/>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  @import '~@/scss/fonts.scss';
  @import '~@/scss/animations';

  .anim-fadein{
    animation: fadeIn 1s forwards;
  }

  #app{
    .v-application {
      [class*='text-'] {
        font-family: $body-font-family !important;
      }
      font-family: $heading-font-family !important;
    }
  }

  .wrapper{
    display: block;
    width: 1500px;
    max-width: 100%;
    margin: auto;
  }

  .gap{
    @for $i from 1 through 5 {
      &-#{$i * 10}{
        gap: #{$i * 10}px;
      }
      @for $j from 1 through 5 {
        &-#{$i * 10}-#{$j * 10}{
          gap: #{$i * 10}px #{$j * 10}px;
        }
      }
    }
  }

  .statsGroup{
    .StatChip{
      flex-grow: 1;
      padding: 20px;
      border-left: 1px solid #E2E2E2;
      &:first-child{
        border-left: 0;
      }
    }
  }

  .Table{
    .v-data-table{
      color: #121212;
      thead{
        tr th{
          font-size: 13px !important;
          &:first-child{
            padding-left: 40px !important;
          }
        }
      }
      tbody {
        /* tr:nth-child(even){
          background: #F8F8F8;
        } */
        tr td{
          padding: 20px !important;
          border-bottom: 1px solid #E2E2E2 !important;
          font-size: 16px !important;
          &:first-child{
            padding-left: 40px !important;
          }
        }
      }
    }
  }

  #app{
    .v-card{
      box-shadow: none;
      border: 1px solid #E2E2E2;
    }
    .v-menu__content{
      box-shadow: none;
      border: 1px solid #E2E2E2;
      .v-card{
        border: 0;
      }
    }
    .v-btn{
      letter-spacing: normal;
      text-transform: none;
      box-shadow: none;
      svg{
        display: inline-block;
        width: auto;
        max-width: 100%;
        height: 2em;
      }
    }
    .text-h4{
      @media screen and (max-width: 960px){
        font-size: 24px !important;
        line-height: 1.1 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue